
const uniquePermissions = (permissions: string[]) => Array.from(new Set(permissions));

export const PermissionsBase = {
    Hub: 'Hub',
    Admin: ['Hub_Admin']
  };

  export const PermissionsReceivingModule = { 
    Read: uniquePermissions(['Hub_Receiving_Read', ...PermissionsBase.Admin]),
    Write: uniquePermissions(['Hub_Receiving_Write', ...PermissionsBase.Admin]),
    Delete: uniquePermissions(['Hub_Receiving_Delete', ...PermissionsBase.Admin])
  };

  export const PermissionsTechRepairModule = {  
    Read: uniquePermissions(['Hub_TechRepair_Read', ...PermissionsBase.Admin]),
    Write: uniquePermissions(['Hub_TechRepair_Write', ...PermissionsBase.Admin]),
    Delete: uniquePermissions(['Hub_TechRepair_Delete', ...PermissionsBase.Admin]),
  };
  
  
  export const PermissionsInspectionModule = {  
    Read: uniquePermissions(['Hub_Inspection_Read', ...PermissionsBase.Admin]),
    Write: uniquePermissions(['Hub_Inspection_Write', ...PermissionsBase.Admin]),
    Delete: uniquePermissions(['Hub_Inspection_Delete', ...PermissionsBase.Admin]),
  };
    
  export const PermissionsBillingModule = { 
    Read: uniquePermissions(['Hub_Billing_Read', ...PermissionsBase.Admin]),
    Write: uniquePermissions(['Hub_Billing_Write', ...PermissionsBase.Admin]),
    Delete: uniquePermissions(['Hub_Billing_Delete', ...PermissionsBase.Admin]),
    DeleteInvoice: uniquePermissions(['Hub_Billing_Delete_Invoice', ...PermissionsBase.Admin])
  };
  
  export const PermissionsEntityModule = { 
    Read: uniquePermissions(['Hub_Entity_Read', ...PermissionsBase.Admin]),
    Write: uniquePermissions(['Hub_Entity_Write', ...PermissionsBase.Admin]),
    Delete: uniquePermissions(['Hub_Entity_Delete']), 
  };
  
  export const PermissionsSalesModule = { 
    Read: uniquePermissions(['Hub_Sales_Read', ...PermissionsBase.Admin]),
    Write: uniquePermissions(['Hub_Sales_Write', ...PermissionsBase.Admin]),
    Delete: uniquePermissions(['Hub_Sales_Delete', ...PermissionsBase.Admin]),
  };

  export const PermissionsZeusModule = { 
    Read: uniquePermissions(['Hub_Zeus_Read', ...PermissionsBase.Admin]),
    Write: ['read-only'],
    Delete: ['read-only']
  };
    
  export const PermissionsInventoryModule = { 
    Read: uniquePermissions(['Hub_Inventory_Read', ...PermissionsBase.Admin]),
    Write: uniquePermissions(['Hub_Inventory_Write', ...PermissionsBase.Admin]),
    Delete: ['read-only']
  };

  export const PermissionsReportModule = { 
    Read: uniquePermissions(['Hub_Report_Read', ...PermissionsBase.Admin]),
    Write: ['read-only'],
    Delete: ['read-only']
  };

  export const PermissionsSettingModule = { 
    Read: uniquePermissions(['Hub_Setting_Read', ...PermissionsBase.Admin]),
    Write: uniquePermissions(['Hub_Setting_Write', ...PermissionsBase.Admin]),
    Delete: uniquePermissions(['Hub_Setting_Delete', ...PermissionsBase.Admin]),
  };

  
  export const PermissionsNote = { 
    Read: PermissionsReceivingModule.Read,
    Write: PermissionsReceivingModule.Write,
    Delete: PermissionsReceivingModule.Delete,
  };

  
  export const PermissionsGroup = {
    ReceivingReadWriteOrDelete: Array.from(
      new Set([
        ...PermissionsReceivingModule.Read,
        ...PermissionsReceivingModule.Write,
        ...PermissionsReceivingModule.Delete,
      ])
    ),

    TechRepairReadWriteOrDelete: Array.from(
      new Set([
        ...PermissionsTechRepairModule.Read,
        ...PermissionsTechRepairModule.Write,
        ...PermissionsTechRepairModule.Delete,
      ])
    ),

    InspectionReadWriteOrDelete: Array.from(
      new Set([
        ...PermissionsInspectionModule.Read,
        ...PermissionsInspectionModule.Write,
        ...PermissionsInspectionModule.Delete,
      ])
    ),

    EntityReadWriteOrDelete: Array.from(
      new Set([
        ...PermissionsEntityModule.Read,
        ...PermissionsEntityModule.Write,
        ...PermissionsEntityModule.Delete,
      ])
    ),

    SalesReadWriteOrDelete: Array.from(
      new Set([
        ...PermissionsSalesModule.Read,
        ...PermissionsSalesModule.Write,
        ...PermissionsSalesModule.Delete,
      ])
    ),

    SettingReadWriteOrDelete: Array.from(
      new Set([
        ...PermissionsSettingModule.Read,
        ...PermissionsSettingModule.Write,
        ...PermissionsSettingModule.Delete,
      ])
    ),

    BillingReadWriteOrDelete: Array.from(
      new Set([
        ...PermissionsBillingModule.Read,
        ...PermissionsBillingModule.Write,
        ...PermissionsBillingModule.Delete,
      ])
    ),

    InventoryReadWriteOrDelete: Array.from(
      new Set([
        ...PermissionsInventoryModule.Read,
        ...PermissionsInventoryModule.Write,
        ...PermissionsInventoryModule.Delete,
      ])
    ),

    ReportReadWriteOrDelete: Array.from(
      new Set([
        ...PermissionsReportModule.Read,
        ...PermissionsReportModule.Write,
        ...PermissionsReportModule.Delete,
      ])
    ),

    ZeusReadWriteOrDelete: Array.from(
      new Set([
        ...PermissionsZeusModule.Read,
        ...PermissionsZeusModule.Write,
        ...PermissionsZeusModule.Delete,
      ])
    ),    
};

  
  
  